import { ChangeDetectionStrategy, Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContinueAsGuest, ResetState } from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { UserService } from '@app/core/user/services/user/user.service';
import * as fromUser from '@app/core/user/store/reducers';
import { CookieService } from '@app/core/cookies';
import { CookieOptions } from './../../../cookies/interfaces';
import { environment } from '@env/environment';
import { take } from 'rxjs/operators';
import { LocaleService } from '@app/core/i18n';

export const BREAKPOINTS = {
  xlarge: 1440,
  large: 1024,
  medium: 768,
  small: 375
};

const promosByCountry = {
  FR: '20€',
  US: '$30',
  UK: '£20',
  DE: '20€',
  ES: '20€',
  IT: '20€',
  DK: '150DKK',
  FI: '20€',
  SE: '200SEK',
  WW: '$20',
  RE: '30€',
  SG: 'S$70',
  HK: 'HK$550',
  AU: 'AU$70'
};

@Component({
  selector: 'vc-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class AuthModalComponent implements OnInit {
  resetPassword: false;
  email: string;
  type: 'login' | 'register' | 'login-register' = 'login';
  popinForced: boolean;
  popover = false;
  registerFirstStep = true;

  public promoOffer = '';
  public firstname: string;

  constructor(
    private store: Store<IAppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private cookieService: CookieService,
    public localeService: LocaleService
  ) {
    if (this.data.type === 'register') {
      this.type = 'register';
    }

    this.popinForced = this.data.forced;
  }

  ngOnInit() {
    this.promoOffer = promosByCountry[this.localeService.getRegionCode()];

    // this.store.dispatch(new ResetState());

    this.userService.getAuthDialogData().subscribe(
      res => {
        if (res) {
          this.email = res.credentials.email;

          if (res.authModalType === 'register') {
            this.type = 'register';
          }
        }
      },
      err => {}
    );

    if (window && window.innerWidth < BREAKPOINTS.medium) {
      this.type = window.innerWidth < BREAKPOINTS.medium ? 'login-register' : this.data.type;
    }
  }

  displayResetPassword(value) {
    this.resetPassword = value;
  }

  displayComponent(name: 'login' | 'register'): void {
    this.store.dispatch(new ResetState());
    this.type = name;
  }

  setCurrentEmail(value) {
    this.email = value;
  }

  togglePopover() {
    this.popover = !this.popover;
  }

  continueAsGuest() {
    const cookieOptions: CookieOptions = {
      domain: environment.cookieOptions.domain,
      expires: 1,
      path: '/'
    };
    this.store.pipe(select(fromUser.isGuestUser), take(1)).subscribe(
      res => {
        if (!res) {
          this.store.dispatch(new ContinueAsGuest(true));
          this.cookieService.set(environment.guestCookie, 'Y', cookieOptions);
        }
      },
      error => console.log(error)
    );
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      // pop in is closed by escape key
      this.continueAsGuest();
    }
  }
}
